import React from "react";
import T from "./t.jsx";
import { EMAIL_REGEXP, displayErrors } from "./validation.jsx";

const TRANSLATE_PREFIX = "submitter-email.";

/**
 * Props:
 *   data: Map({
 *     enabled: boolean,
 *     errors:  Array<string>,
 *     text:    string,
 *     dirty:   boolean
 *   })
 */
export default class SubmitterEmail extends React.Component {
  constructor(props) {
    super(props);

    this.onCheckbox = event => {
      this.props.onChange(
        this.props.data.merge({
          enabled: event.target.checked,
          errors: this.validate(
            this.props.data.get("text", ""),
            event.target.checked
          ),
          dirty: true,
          text: this.props.data.get("text", "")
        })
      );
    };
    this.onInput = event => {
      let text = event.target.value.substr(0, 2044);

      this.props.onChange(
        this.props.data.merge({
          text: text,
          errors: this.validate(text, this.props.data.get("enabled", true)),
          dirty: true
        })
      );
    };
  }
  validate(text, enabled) {
    var errors = enabled && text.length === 0 ? ["question-required"] : [];

    if (enabled && !EMAIL_REGEXP.test(text) && text.length > 0) {
      errors.push("invalid-email");
    }

    return errors;
  }
  shouldComponentUpdate(nextProps) {
    return (
      nextProps.data !== this.props.data || nextProps.type !== this.props.type
    );
  }
  render() {
    return (
      <div className="submitter-copy">
        <div className="submitter-copy__wrap cf">
          <div className="checkbox__item submitter-copy__checkbox">
            <input
              type="checkbox"
              className="checkbox__input"
              id="submitter_email_enabled"
              checked={this.props.data.get("enabled", false)}
              onChange={this.onCheckbox}
            />

            <T
              component="label"
              className="checkbox__label"
              htmlFor="submitter_email_enabled"
            >
              {TRANSLATE_PREFIX + "enable"}
            </T>
          </div>

          <input
            value={this.props.data.get("text", "")}
            className="submitter-copy__input"
            type="text"
            onChange={this.onInput}
          />
        </div>

        {this.props.data.get("enabled", true)
          ? displayErrors(this.props.data)
          : null}
      </div>
    );
  }
}
